module.exports = __webpack_public_path__ + "img/kkp-bk.74f7137f.svg";